import { makeStyles } from '@material-ui/core';
import hashicorpMark from '../../assets/logos/hashicorp-mark.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img src={hashicorpMark} alt="HashiCorp" className={classes.img} />;
};

export default LogoIcon;
